<template>
  <textarea class="form-control" v-model="localValue" :name="name" :rows="rows">
  </textarea>
</template>

<script>
import { fieldMixin, formErrorMixin } from "../../../mixins";

export default {
  mixins: [fieldMixin, formErrorMixin],

  props: {
    value: {},
    rows: {
      type: [Number, String],
      default: 2
    }
  },

  data() {
    return {
      localValue: this.value
    };
  },

  watch: {
    value(newVal, oldVal) {
      this.localValue = newVal;
    },

    localValue(newVal, oldVal) {
      this.$emit("input", this.localValue);
    }
  }
};
</script>
